<template>
  <div class="dropdown ap-dropdown">
    <a class="nav-link" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
      {{text}}
      <span class="caret"></span>
    </a>
    <div class="dropdown-arrow"></div>
    <div class="dropdown-menu dropdown-menu-rich dropdown-menu-right" x-placement="bottom-end">
      <slot name="menus"></slot>
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      text: String
    }
  }
</script>